module.exports = __webpack_public_path__ + "img/vodacom-cricket-background-desktop.116445f7.png";